import React from 'react';
import { NavLink, Link } from 'react-router-dom';
// import { DropdownButton, Dropdown } from 'react-bootstrap';
// import ReactTooltip from 'react-tooltip';
import { local_routes } from 'utils/Routes';
import { org_friendly_url } from 'Api/Api';
// , user_access_level, user_account_level
import './style.css';

//import DownloadAssetsButton from 'components/DownloadAssetsButton/DownloadAssetsButton';

export default class OrphanedPresentationTable extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            showComponent: false,
            assets_array: []
        };
        this.workspace_base_url = "";
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
        
        //console.log("YOYO",props.presenter_info);
    }

    onClickAccept = () => {
        console.log("onClickAccept");
        if (!this.props.presenter_info) {
          console.error("ERROR no presenter_info");
          return;
        }
        this.props.acceptPK(this.props.presentation_info,this.props.presenter_info);
    }

    onClickReject = () => {
        console.log("onClickReject");
        this.props.rejectPK(this.props.presentation_info);
    }

    render(){
        return (
            <React.Fragment>
            <tr className="">
                <td className="border-none" style={{ width: "30%" }}>
                    { (this.props.presentation_info.status_code === 1 && this.props.presentation_info.friendly_url) ?
                    <Link target="_blank" to={`${this.workspace_base_url}${local_routes.presentations}/${this.props.presentation_info.friendly_url}`}>
                        {this.props.presentation_info.entity_name}
                    </Link>
                    :
                    <React.Fragment>
                        {this.props.presentation_info.entity_name}
                    </React.Fragment>
                    }
                </td>
                <td className="border-none" style={{ width: "35%" }}>
                  { (this.props.presenter_info && this.props.presenter_info.status_code === 1 && this.props.presenter_info.friendly_url) ?
                      <Link target="_blank" to={`${this.workspace_base_url}${local_routes.users}/${this.props.presenter_info.friendly_url}`}>
                          {this.props.presenter_info.friendly_url}
                      </Link>
                    :
                    <React.Fragment>
                      { (this.props.presenter_info && this.props.presenter_info.friendly_url) ?
                        <React.Fragment>
                          {this.props.presenter_info.friendly_url}
                        </React.Fragment>
                        :
                        <React.Fragment>
                          Unknown Presenter
                        </React.Fragment>
                      }
                    </React.Fragment>
                  }                    
                </td>
                <td className="border-none" style={{ width: "15%", display: "flex" }}>
                    { (this.props.presenter_info && this.props.presenter_info.status_code === 1) &&
                      <div>
                          <button 
                              className="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons" 
                              onClick={this.onClickAccept}
                          >
                              Add Presenter to Event
                          </button>
                      </div>
                    }
                    <div>
                        <button 
                            className="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons" 
                            onClick={this.onClickReject}
                        >
                            Remove Presentation from Event
                        </button>
                    </div>
                  
                </td>
            </tr>

            </React.Fragment>
        );
    }
}